import Axios from "../config/axios-v1-config";

export const getRoutesApi = async () => {
    const clients = await Axios.get("routes").catch((err) => {
      return { error: err.response.data };
    });
  
    return clients;
  };

export const getRoute = async (routeId) => {
  const clients = await Axios.get("routes/" + routeId).catch((err) => {
    return { error: err.response.data };
  });

  return clients;
};

export const getRoutesWithDetails = async () => {
  const clients = await Axios.get("routes/routesWithDetails").catch((err) => {
    return { error: err.response.data };
  });

  //console.log("clients: ", clients);
  return clients.data;
};


export const addRouteApi = async (newRoute) => {
  try {
    const response = await Axios.post("routes", newRoute);
    return response.data; // Retornar los datos de la respuesta en caso de éxito
  } catch (error) {
    console.error("Error al crear la ruta:", error);
    return { error: error.response ? error.response.data : error.message };
  }
};

export const addToRouteApi = async (routeId, clientsId) => {
  await Axios.post("addToRoute", {id: routeId, clientsId}).catch((err) => {
      return { error: err.response.data };
      });
  }


export const deleteRoutesApi = async (routeId) => {
  try {
    const response = await Axios.delete("routes", {
      data: { id: routeId },
    });
    return response.data;
  } catch (err) {
    return { error: err.response.data };
  }
};

export const deleteClientFromRouteApi = async (routeId, clientId) => {
  await Axios.post("deleteClient", {id: routeId, clientId}).catch((err) => {
      return { error: err.response.data };
      });
  }

export const assignDeliveryApi = async (routeId, deliveryId) => {
  await Axios.patch(`routes/${routeId}`, {data: {deliveryMan: deliveryId}}).catch((err) => {
    return { error: err.response.data };
  });
}

export const updateRoute = async (routeId, updatedRouteData) => {
  try {
    const response = await Axios.patch(`routes/${routeId}`, { data: updatedRouteData });
    return response.data;
  } catch (error) {
    return { error: error.response ? error.response.data : error.message };
  }
};


export const getDeliveredPackages = async (date, { logisticCompanyId, companyId, timezone } = {}) => {
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const params = new URLSearchParams({ date, timezone: tz });
  if (logisticCompanyId) params.set('logisticCompanyId', logisticCompanyId);
  if (companyId) params.set('companyId', companyId);
  const { data } = await Axios.get(`routes/packagesGroupedByDeliverer?${params}`);
  return data.data;
}

export const getPackageImages = async (followingNumber) => {
  const { data } = await Axios.get(`routes/package/${followingNumber}/images`);
  return data.data;
}

// Sesión de ruta ACTIVE de un repartidor (vista de operador). El backend scopea
// por tenant vía JWT; 404 = el repartidor no tiene ruta activa (caso normal).
export const getDriverActiveRouteSession = async (driverId) => {
  const { data } = await Axios.get(`driver-route-sessions/by-driver/${driverId}/active`);
  return data.data;
}

// ETA por parada de la ruta activa, recalculado contra la posición VIVA del repartidor.
// Va aparte de la sesión y no dentro de ella porque tiene otro costo y otra frescura: la sesión
// se lee de Mongo, esto consulta la posición y el motor de ruteo. Mismo scope por tenant y mismo
// 404 = sin ruta activa.
export const getDriverStopEtas = async (driverId) => {
  const { data } = await Axios.get(`driver-route-sessions/by-driver/${driverId}/stop-etas`);
  return data.data;
}